import { Box, Typography } from 'src/components/MuiGenerals';
import { useTranslation } from 'src/hooks';
import { DialogInOne } from 'src/components';
import { Dispatch, SetStateAction } from 'react';

type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const InvalidRecordReminderDialog = (props: Props) => {
  const { isOpen, setIsOpen } = props;
  const { t } = useTranslation('clientCreditAllocation');
  return (
    <DialogInOne
      content={
        <Box>
          <Typography variant="h6">{t('recordsWithError')}</Typography>
          <Typography variant="h6">{t('reuploadOrCheck')}</Typography>
        </Box>
      }
      isConfirmHidden
      title={''}
      self={{
        open: isOpen,
        onClose: () => setIsOpen(false),
      }}
      onConfirm={() => {}}
      onCancel={() => setIsOpen(false)}
    />
  );
};

export default InvalidRecordReminderDialog;
